import { EmbeddedJar } from './EmbeddedJar';

export const EmbeddedJarContainer = () => {
  return <EmbeddedJar />;
};
